import React, { useEffect } from 'react';
import { Amplify, API } from 'aws-amplify';
import config from '../../aws-exports';
import { Amplify as AmplifySingleton } from './Amplify';
import { Api as ApiSingleton } from './Api';


const Loader = props => {

  const {
    onLoaded,
  } = props;

  useEffect(
    () => {
      const configuration = {
        ...config,
        // https://github.com/aws-amplify/amplify-js/issues/5918
        Analytics: { disabled: true },
      };
      Amplify.configure(configuration);
      API.configure(configuration);
      AmplifySingleton.Set(Amplify);
      ApiSingleton.Set(API);
      if (onLoaded) {
        onLoaded();
      }
    },
    [
      onLoaded,
    ],
  );

  return <></>;
};

export default Loader;
